<template>
  <div class="projectPortrait">
    <div class="cardList">
      <div v-for="(item,index) in cardList" :key="index" @click="goDetail(item.id)">
        <el-card class="box-card">
          <div class="cardCont">
            <img class="cardImg" :src="item.url" />
          </div>
          <p class="cardTitle">{{item.title}}</p>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:projectPortrait
   *@Description:项目画像
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-07-11
   */
  // import { mapGetters } from 'vuex'icon_project
  import icon1 from '../../assets/imgs/icon_project01.png'
  import icon2 from '../../assets/imgs/icon_project02.png'
  import icon3 from '../../assets/imgs/icon_project03.png'
  import icon4 from '../../assets/imgs/icon_project04.png'
  // import icon5 from '../../assets/imgs/icon_project05.png'
  import icon6 from '../../assets/imgs/icon_project06.png'
  // import icon7 from '../../assets/imgs/icon_project07.png'
  import icon8 from '../../assets/imgs/icon_project08.png'
  // import icon9 from '../../assets/imgs/icon_project09.png'
  import icon10 from '../../assets/imgs/icon_project10.png'
  export default {
    name: '/manage/main.projectPortrait',
    data() {
      return {
        cardList: [{
            id: 1,
            title: '企业党组织建设情况',
            url: icon1
          },
          {
            id: 2,
            title: '小区党组织建设情况',
            url: icon2
          },
          {
            id: 3,
            title: '物业企业信息管理',
            url: icon3
          },
          {
            id: 4,
            title: '物业服务合同管理',
            url: icon4
          },
          // {
          //   id: 5,
          //   title: '物业承接查验管理',
          //   url: icon5
          // },
          {
            id: 6,
            title: '物业小区信息管理',
            url: icon6
          },
          // {
          //   id: 7,
          //   title: '小区住户管理',
          //   url: icon7
          // },
          {
            id: 8,
            title: '小区负责人管理',
            url: icon8
          },
          // {
          //   id: 9,
          //   title: '小区管家信息管理',
          //   url: icon9
          // },
          {
            id: 10,
            title: '小区服务人员管理',
            url: icon10
          }
        ]
      }
    },
    created() {

    },
    methods: {
      goDetail(id) {
        if (id == 1) {
          this.$router.push({
            name: 'enterpriseParty'
          })
        } else if (id == 2) {
          this.$router.push({
            name: 'gardenParty'
          })
        } else if (id == 3) {
          this.$router.push({
            name: 'propertyEnterpriseInfo'
          })
        } else if (id == 4) {
          this.$router.push({
            name: 'propertyContractList'
          })
        } else if (id == 6) {
          this.$router.push({
            name: 'gardenInfoAdministration'
          })
        } else if (id == 8) {
          this.$router.push({
            name: 'addLeaderInfo'
          })
        } else if (id == 10) {
          this.$router.push({
            name: 'addServiceInfo'
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .projectPortrait {
    .cardList {
      display: flex;
      flex-wrap: wrap;
    }

    .box-card {
      margin: 20px;
      padding: 20px;
    }

    .box-card .el-card__body {
      display: flex;
    }

    .cardCont {
      width: 65px;
      height: 65px;
    }

    .cardImg {
      width: 100%;
      height: 100%;
    }

    .cardTitle {
      line-height: 65px;
      font-size: 24px;
      margin: 0 10px;
      color: #999;
    }
  }
</style>